import { type Location } from '@koala/sdk';
import { getLocationPillLabel } from './utils';
import { useSelector } from '@/redux';

/** "Brand · Location" for a store, with the brand from the organization. */
export function useLocationPillLabel(location: Pick<Location, 'label' | 'cached_data'>): string {
  const brandLabel = useSelector((state) => state.app.organization.organization?.label);

  return getLocationPillLabel(location, brandLabel);
}
